"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("./api");
class TextApi {
    constructor(api) {
        this.api = api;
    }
    async get(endpoint, queryParams) {
        return this.request(api_1.Method.GET, endpoint, queryParams);
    }
    async request(method, endpoint, queryParams) {
        const response = await this.api.request(method, endpoint, queryParams, {
            Accept: "text/plain",
        });
        return await response.text();
    }
}
exports.default = TextApi;
//# sourceMappingURL=text-api.js.map